$(function () {
    if (typeof calendarData === 'undefined') {
        return;
    }

    // Update what is visible
    function updateView() {
        let location = $('#calendar-location').val();
        let $calendarLinks = $('#calendario').find('a');
        $calendarLinks.hide();

        if (location) {
            // $('.custom-calendar-wrap').show();
            $calendarLinks.filter('.' + location).show();
        } else {
            // $('.custom-calendar-wrap').hide();
        }
    }

    // Setup calendar
    let cal = $('#calendario').calendario({
        caldata: calendarData,
        startIn: 0,
        onDayClick: function ($el, $contentEl, dateProperties) {
            for (let key in dateProperties) {
                console.log(key + ' = ' + dateProperties[key]);
            }
        }
    });

    // Get current month & year
    let $month = $('#custom-month').html(cal.getMonthName());
    let $year = $('#custom-year').html(cal.getYear());

    // Update month & year
    function updateMonthYear() {
        $month.html(cal.getMonthName());
        $year.html(cal.getYear());
    }

    // On click events
    $('#custom-next').on('click', function () {
        cal.gotoNextMonth(updateMonthYear);
        updateView();
    });
    $('#custom-prev').on('click', function () {
        cal.gotoPreviousMonth(updateMonthYear);
        updateView();
    });
    $('#custom-current').on('click', function () {
        cal.gotoNow(updateMonthYear);
        updateView();
    });
    $('#calendar-location').on('change', function () {
        updateView();
    }).val(calendarLocation);

    // Initialize calendar view
    updateView();
});